// One row of "here is another way to say it". Lifted from the Andon app's
// `PickerRow`.
//
// WHY A ROW AND NOT A PILL.
//
// Two of the five need a second line to be honest. "drawing, PDF" is what makes
// an upload row mean something to somebody holding a paper drawing, and
// "transcribes" is what stops a person expecting the words to stay in the
// clip. Pills have room for one word each — so the two rows that most needed
// explaining were the two that got the least.

import { Icon, type IconName } from '@/components/ui/Icon';

export function PickerRow({
  icon,
  label,
  hint,
  disabled,
  onClick,
}: {
  icon: IconName;
  label: string;
  /** The second line, on the rows where one word is not enough. */
  hint?: string | undefined;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="press-row"
      disabled={disabled}
      onClick={onClick}
      style={{
        width: '100%',
        height: 54,
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        padding: '0 18px',
        color: 'var(--ink)',
        opacity: disabled ? 0.55 : 1,
        borderBottom: '1px solid var(--line)',
      }}
    >
      <Icon name={icon} size={20} strokeWidth={1.8} />
      <span style={{ font: '500 14px Manrope,sans-serif' }}>{label}</span>
      {hint && <span style={{ marginLeft: 'auto', font: '600 10.5px Manrope,sans-serif', color: 'var(--sub)' }}>{hint}</span>}
    </button>
  );
}
